import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Route from '@/components/Route'
import TextareaAutosize from 'vue-textarea-autosize'
import VueClipboard from 'vue-clipboard2'

import './registerServiceWorker'
import '@/utils/iconImports'
import '@/mixins/global'

import '@/assets/css/tailwind.css'

Vue.config.productionTip = false

Vue.component('route', Route)
Vue.use(TextareaAutosize)

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
